import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apis from '../services';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('DEX');
  const [tabData, setTabData] = useState({
    DEX: [],
    CEX: [],
    ICO: [],
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch all data at once
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await apis.listing({ page_size: 50 });
      const allData = response.data || {};

      const formatTabData = (data, tab) =>
        (data || []).map(({ details, _id }) => {
          if (tab === 'ICO') {
            return {
              name: details.tokenName || 'N/A',
              totalRaised: details.totalRaised || 'N/A',
              Round: details.Round || 'N/A',
              preValuation: details.preValuation || 'N/A',
              category: details.category || 'N/A',
              date: details.Date || 'N/A',
              image: details.image || '',
              tokenAddress: details.tokenAddress,
              id: details._id, 
            };
          } else {
            return {
              name: details.tokenName || 'N/A',
              price: details.price,
              age: details.Age || 'N/A',
              txn: details.totalTransactions,
              fiveMin: details.pricePercentage.m5,
              oneHr: details.pricePercentage.h1,
              sixHr: details.pricePercentage.h6,
              twentyFourHr: details.pricePercentage.h24,
              vol: details.volume,
              liq: details.liquidity,
              mcap: details.Mcap,
              fdv: details.fdv,
              tokenAddress: details.tokenAddress,
              chainName: details.chainName || 'unknown',
            };
          }
        });

      // Format and set data for all tabs
      setTabData({
        DEX: formatTabData(allData.DEX, 'DEX'),
        CEX: formatTabData(allData.CEX, 'CEX'),
        ICO: formatTabData(allData.ICO, 'ICO'),
      });
    } catch (err) {
      console.error('Error fetching data:', err.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle row click for navigation
  const handleRowClick = async (row) => {
    if (activeTab === 'ICO') {
      try {
        // Pass _id to the newico API
        const data = await apis.newico(row.id);
        navigate(`/PS-detail`, { state: { id: row.id, apiData: data } });
      } catch (error) {
        console.error('Error fetching ICO details:', error);
      }
    } else if (activeTab === 'DEX' && row.chainName.toLowerCase() === 'solana') {
    } else {
      navigate(`/details/${row.tokenAddress}?chainName=${row.chainName}`);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="dashboard-container">
      {/* Buttons for toggling tabs */}
      <div className="tab-buttons">
        {['DEX', 'CEX', 'ICO'].map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => handleTabChange(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Data Table */}
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="table-container-new custom-scrollbar">
          {tabData[activeTab].length === 0 ? (
            <div className="data-message">
              <div className="no-data-message">Data not available</div>
            </div>
          ) : (
            <table className="table-table-container">
              <thead className="active-header">
                <tr>
                  {activeTab === 'ICO' ? (
                    <>
                      <th>Token Name</th>
                      <th>Round</th>
                      <th>Total Raised</th>
                      <th>Pre-Valuation</th>
                      <th>Category</th>
                      <th>Date</th>
                    </>
                  ) : (
                    <>
                      <th>Coin Name</th>
                      <th>Price</th>
                      <th>Age</th>
                      <th>TXN</th>
                      <th>5M</th>
                      <th>1H</th>
                      <th>6H</th>
                      <th>24H</th>
                      <th>VOL</th>
                      <th>LIQ</th>
                      <th>MCAP</th>
                      <th>FDV</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {tabData[activeTab].map((row, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(row)}
                    style={{ cursor: 'pointer' }}
                  >
                    {activeTab === 'ICO' ? (
                      <>
                        <td>
                          <div className="ico-cell">
                            <img
                              src={row.image}
                              alt={`${row.name} logo`}
                              className="ico-image"
                              onError={(e) => (e.target.style.display = 'none')}
                            />
                            <span>{row.name}</span>
                          </div>
                        </td>
                        <td>{row.Round}</td>
                        <td>{row.totalRaised}</td>
                        <td>{row.preValuation}</td>
                        <td>{row.category}</td>
                        <td>{row.date}</td>
                      </>
                    ) : (
                      <>
                        <td className="clickable-cell">{row.name}</td>
                        <td>{row.price}</td>
                        <td>{row.age}</td>
                        <td>{row.txn}</td>
                        {/* <td className={parseFloat(row.fiveMin) < 0 ? 'negative' : ''}>
                          {row.fiveMin}
                        </td>
                        <td className={parseFloat(row.oneHr) < 0 ? 'negative' : ''}>
                          {row.oneHr}
                        </td>
                        <td className={parseFloat(row.sixHr) < 0 ? 'negative' : ''}>
                          {row.sixHr}
                        </td>
                        <td className={parseFloat(row.twentyFourHr) < 0 ? 'negative' : ''}>
                          {row.twentyFourHr}
                        </td> */}
                        <td style={{ color: parseFloat(row.fiveMin) < 0 ? 'red' : 'green' }}>
  {row.fiveMin}
</td>
<td style={{ color: parseFloat(row.oneHr) < 0 ? 'red' : 'green' }}>
  {row.oneHr}
</td>
<td style={{ color: parseFloat(row.sixHr) < 0 ? 'red' : 'green' }}>
  {row.sixHr}
</td>
<td style={{ color: parseFloat(row.twentyFourHr) < 0 ? 'red' : 'green' }}>
  {row.twentyFourHr}
</td>

                        <td>{row.vol}</td>
                        <td>{row.liq}</td>
                        <td>{row.mcap}</td>
                        <td>{row.fdv}</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default Dashboard;









// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import apis from '../services';
// const Dashboard = () => {
//   const [activeTab, setActiveTab] = useState('DEX'); 
//   const [tabData, setTabData] = useState({
//     DEX: [],
//     CEX: [],
//     ICO: [],
//   });
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   // Fetch all data at once
//   const fetchAllData = async () => {
//     setLoading(true);
//     try {
//       const response = await apis.listing({ page_size: 50 });
//       const allData = response.data || {};

//       const formatTabData = (data, tab) =>
//         (data || []).map(({ details }) => {
//           if (tab === 'ICO') {
//             return {
//               name: details.tokenName || 'N/A',
//               totalRaised: details.totalRaised || 'N/A',
//               preValuation: details.preValuation || 'N/A',
//               category: details.category || 'N/A',
//               date: details.Date || 'N/A',
//               image: details.image || '',
//             };
//           } else {
//             return {
//               name: details.tokenName || 'N/A',
//               price: details.price,
//               age: details.Age || 'N/A',
//               txn: details.totalTransactions,
//               fiveMin: details.pricePercentage.m5,
//               oneHr: details.pricePercentage.h1,
//               sixHr: details.pricePercentage.h6,
//               twentyFourHr: details.pricePercentage.h24,
//               vol: details.volume,
//               liq: details.liquidity,
//               mcap: details.Mcap,
//               fdv: details.fdv,
//               tokenAddress: details.tokenAddress, 
//               chainName: details.chainName || 'unknown', 
//             };
//           }
//         });

//       // Format and set data for all tabs
//       setTabData({
//         DEX: formatTabData(allData.DEX, 'DEX'),
//         CEX: formatTabData(allData.CEX, 'CEX'),
//         ICO: formatTabData(allData.ICO, 'ICO'),
//       });
//     } catch (err) {
//       console.error('Error fetching data:', err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

  
//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//   };

// // detail page fun ..............................................................
//   const handleRowClick = (e, tokenAddress, chainName) => {
//     if (e.target.closest('.clickable-cell')) {
//       navigate(`/details/${tokenAddress}?chainName=${chainName}`);
//     }
//   };
// //   
//   return (
//     <div className="dashboard-container">
//       {/* Buttons for toggling tabs */}
//       <div className="tab-buttons">
//         {['DEX', 'CEX', 'ICO'].map((tab) => (
//           <button
//             key={tab}
//             className={`tab-button ${activeTab === tab ? 'active' : ''}`}
//             onClick={() => handleTabChange(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Data Table */}
//       {loading ? (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       ) : (
//         <div className="table-container-new custom-scrollbar">
//           {tabData[activeTab].length === 0 ? (
//             // Show message if no data is available
//             <div className="data-message">
//               <div className="no-data-message">Data not available</div>
//             </div>
//           ) : (
//             <table className="table-table-container">
//               <thead className="active-header">
//                 <tr>
//                   {activeTab === 'ICO' ? (
//                     <>
//                       <th>Token Name</th>
//                       <th>Total Raised</th>
//                       <th>Pre-Valuation</th>
//                       <th>Category</th>
//                       <th>Date</th>
//                     </>
//                   ) : (
//                     <>
//                       <th>Coin Name</th>
//                       <th>Price</th>
//                       <th>Age</th>
//                       <th>TXN</th>
//                       <th>5M</th>
//                       <th>1H</th>
//                       <th>6H</th>
//                       <th>24H</th>
//                       <th>VOL</th>
//                       <th>LIQ</th>
//                       <th>MCAP</th>
//                       <th>FDV</th>
//                     </>
//                   )}
//                 </tr>
//               </thead>
//               <tbody>
//                 {tabData[activeTab].map((row, index) => (
//                   <tr key={index} onClick={(e) => handleRowClick(e, row.tokenAddress, row.chainName)}>
//                     {activeTab === 'ICO' ? (
//                       <>
//                         <td>
//                           <div className="ico-cell">
//                             <img
//                               src={row.image}
//                               alt={`${row.name} logo`}
//                               className="ico-image"
//                               onError={(e) => (e.target.style.display = 'none')} // Hide if the image fails to load
//                             />
//                             <span>{row.name}</span>
//                           </div>
//                         </td>
//                         <td>{row.totalRaised}</td>
//                         <td>{row.preValuation}</td>
//                         <td>{row.category}</td>
//                         <td>{row.date}</td>
//                       </>
//                     ) : (
//                       <>
//                         <td className="clickable-cell">{row.name}</td>
//                         <td>{row.price}</td>
//                         <td>{row.age}</td>
//                         <td>{row.txn}</td>
//                         <td className={parseFloat(row.fiveMin) < 0 ? 'negative' : ''}>{row.fiveMin}</td>
//                         <td className={parseFloat(row.oneHr) < 0 ? 'negative' : ''}>{row.oneHr}</td>
//                         <td className={parseFloat(row.sixHr) < 0 ? 'negative' : ''}>{row.sixHr}</td>
//                         <td className={parseFloat(row.twentyFourHr) < 0 ? 'negative' : ''}>{row.twentyFourHr}</td>
//                         <td>{row.vol}</td>
//                         <td>{row.liq}</td>
//                         <td>{row.mcap}</td>
//                         <td>{row.fdv}</td>
//                       </>
//                     )}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard;